import React, { useEffect, useState, useContext } from "react";
import { Loader } from "../../components/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faMagnifyingGlass,
  faPlus,
  faSave,
  faTruck,
} from "@fortawesome/free-solid-svg-icons";
import Modal from "react-bootstrap/Modal";
import { Input } from "../../components/General/Input";
import useCeo from "../../hooks/useCEO";
import Select from "react-select";
import { useUnidades } from "../../hooks/test/useUnidades";
import Swal from "sweetalert2";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { AuthContext } from "../../context/authContext/authContext";
import MUIDataTable from "mui-datatables";
import { toast } from "react-toastify";

export const AdministracionUnidades = () => {
  useCeo({
    title: "Módulo de Administración de unidades",
    description: "Página de unidades",
  });

  const inicialFormUnidad = {
    unidad_id: "",
    numero_serie: null,
    tipo_unidad_id: null,
    unidad_placas: "",
    unidad_marca: "",
    marcaId: "",
    unidad_submarca: "",
    unidad_modelo: "",
    unidad_color: "",
    unidad_color_id: "",
    descripcion: "",
    cliente: "",
    cliente_gestor: "",
    cliente_gestor_telefono: "",
  };

  const {
    getTiposVehiculos,
    postVehiculos,
    getUnidadesTipo,
    putActUnidadesAutosMotos,
    getCatalogos,
    getSubmarcas,
    getVehiculoSearch,
  } = useUnidades();
  const [form, setForm] = useState(inicialFormUnidad);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    reset();
  };
  const [tiposVehiculos, setTiposVehiculos] = useState([]);
  const [dataAutos, setDataAutos] = useState([]);
  const [dataMotos, setDataMotos] = useState([]);
  const [editarUnidad, setEditarUnidad] = useState(false);
  const [editarMoto, setEditarMoto] = useState(false);
  const [editarAuto, setEditarAuto] = useState(false);
  const [catalogos, setCatalogos] = useState([]);
  const [catColores, setCatColores] = useState([]);
  const [catModelos, setCatModelos] = useState([]);
  const [catMarcasMotos, setCatMarcasMotos] = useState([]);
  const [catMarcasAutos, setCatMarcasAutos] = useState([]);
  const [catSubMarcas, setCatSubMarcas] = useState([]);
  const [tipoUnidad, setTipoUnidad] = useState(3);
  const [search, setSearch] = useState("");

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const fetchUnidades = async () => {
      let resp = await getUnidadesTipo(tipoUnidad, 1, 100);
      if (resp.ok) {
        let array = [];
        resp.vehiculos.map((registro) => {
          const {
            unidad_vin,
            unidad_placas,
            unidad_marca,
            unidad_modelo,
            unidad_color,
            descripcion,
            isActive,
          } = registro;

          let aux = [
            unidad_vin ? unidad_vin : "N/A",
            unidad_placas ? unidad_placas : "N/A",
            unidad_marca ? unidad_marca : "N/A",
            unidad_modelo ? unidad_modelo : "N/A",
            unidad_color ? unidad_color : "N/A",
            descripcion ? descripcion : "N/A",
            isActive === true ? "ACTIVA" : "N/A",
            <>
              <FontAwesomeIcon
                icon={faEdit}
                className="fa-2x text-secondary cursor"
                onClick={(e) => {
                  if (tipoUnidad === 3) {
                    setEditarMoto(true);
                    setEditarAuto(false);
                  }
                  if (tipoUnidad === 4) {
                    setEditarMoto(false);
                    setEditarAuto(true);
                  }
                  handleShow();
                  setEditarUnidad(true);
                  traerUnidad(e, registro);
                }}
                title="Editar unidad"
              />
            </>,
          ];
          array.push(aux);
          return null;
        });

        if (tipoUnidad === 3) setDataMotos([...array]);
        if (tipoUnidad === 4) setDataAutos([...array]);
      }
    };

    fetchUnidades();
  }, [tipoUnidad]);

  const handleChangeSearch = async (e) => {
    const newSearchValue = e.target.value;
    setSearch(newSearchValue);

    try {
      if (newSearchValue !== "") {
        let resp = await getVehiculoSearch(newSearchValue, tipoUnidad, 1, 100);
        if (resp.ok) {
          let array = [];
          resp.vehiculos.map((registro) => {
            const {
              unidad_vin,
              unidad_placas,
              unidad_marca,
              unidad_modelo,
              unidad_color,
              descripcion,
              isActive,
            } = registro;

            let aux = [
              unidad_vin ? unidad_vin : "N/A",
              unidad_placas ? unidad_placas : "N/A",
              unidad_marca ? unidad_marca : "N/A",
              unidad_modelo ? unidad_modelo : "N/A",
              unidad_color ? unidad_color : "N/A",
              descripcion ? descripcion : "N/A",
              isActive === true ? "ACTIVA" : "N/A",
              <>
                <FontAwesomeIcon
                  icon={faEdit}
                  className="fa-2x text-secondary cursor"
                  onClick={(e) => {
                    if (tipoUnidad === 3) {
                      setEditarMoto(true);
                      setEditarAuto(false);
                    }
                    if (tipoUnidad === 4) {
                      setEditarMoto(false);
                      setEditarAuto(true);
                    }
                    handleShow();
                    setEditarUnidad(true);
                    traerUnidad(e, registro);
                  }}
                  title="Editar unidad"
                />
              </>,
            ];
            array.push(aux);
            return null;
          });

          if (tipoUnidad === 3) setDataMotos([...array]);
          if (tipoUnidad === 4) setDataAutos([...array]);
        } else {
          return toast.warning(`${resp.msg}`, {
            position: toast.POSITION.BOTTOM_RIGHT, 
            timer: 3000
          });
          // Swal.fire({
          //   title: "Lo siento",
          //   text: resp.msg,
          //   showConfirmButton: false,
          //   icon: "warning",
          //   timer: 3000,
          // });
        }
      } else {
        let resp = await getUnidadesTipo(tipoUnidad, 1, 100);
        if (resp.ok) {
          let array = [];
          resp.vehiculos.map((registro) => {
            const {
              unidad_vin,
              unidad_placas,
              unidad_marca,
              unidad_modelo,
              unidad_color,
              descripcion,
              isActive,
            } = registro;

            let aux = [
              unidad_vin ? unidad_vin : "N/A",
              unidad_placas ? unidad_placas : "N/A",
              unidad_marca ? unidad_marca : "N/A",
              unidad_modelo ? unidad_modelo : "N/A",
              unidad_color ? unidad_color : "N/A",
              descripcion ? descripcion : "N/A",
              isActive === true ? "ACTIVA" : "N/A",
              <>
                <FontAwesomeIcon
                  icon={faEdit}
                  className="fa-2x text-secondary cursor"
                  onClick={(e) => {
                    if (tipoUnidad === 3) {
                      setEditarMoto(true);
                      setEditarAuto(false);
                    }
                    if (tipoUnidad === 4) {
                      setEditarMoto(false);
                      setEditarAuto(true);
                    }
                    handleShow();
                    setEditarUnidad(true);
                    traerUnidad(e, registro);
                  }}
                  title="Editar unidad"
                />
              </>,
            ];
            array.push(aux);
            return null;
          });

          if (tipoUnidad === 3) setDataMotos([...array]);
          if (tipoUnidad === 4) setDataAutos([...array]);
        }
      }
      //   const resp = await getVehiculoSearch(newSearchValue, tipoUnidad, 1, 5);
    } catch (error) {
      console.error("Error al realizar la búsqueda:", error);
    }
  };

  const reset = () => {
    setForm(inicialFormUnidad);
    getData();
    setEditarUnidad(false);
  };

  console.log(tipoUnidad);

  const getData = async () => {
    setLoading(true);
    let resp = await getTiposVehiculos();
    if (resp.ok) setTiposVehiculos(resp.data);
    let result = await getCatalogos(5); // clientes
    if (result.ok) setCatalogos(result.registros);
    let res = await getCatalogos(1); // colores
    if (res.ok) setCatColores(res.registros);
    let re = await getCatalogos(2); // marcas
    if (re.ok) {
      setCatMarcasMotos(re.motos.registros); // Marcas motos
      setCatMarcasAutos(re.autos.registros); // Marcas autos
    }
    let r = await getCatalogos(4); // modelos
    if (r.ok) setCatModelos(r.registros);
    setLoading(false);
  };

  const columns = [
    "Unidad vin",
    "Placas",
    "Marca",
    "Modelo",
    "Color",
    "Descripción",
    "Estatus",
    "Acciones",
  ];

  const options = {
    selectableRows: "none",
    downloadOptions: {
      filename: "unidades.csv",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
      CharacterData: "utf-8",
      CharSet: "utf-8",
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
    textLabels: {
      body: {
        noMatch: "No se encontraron registros",
        toolTip: "Ordenar",
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
      },
      pagination: {
        next: "Página siguiente",
        previous: "Página anterior",
        rowsPerPage: "Filas por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtro de tabla",
      },
      filter: {
        all: "TODOS",
        title: "FILTROS",
        reset: "LIMPIAR",
      },
      viewColumns: {
        title: "Mostrar columnas",
        titleAria: "Mostrar/Ocultar columnas de tabla",
      },
      selectedRows: {
        text: "Fila(s) seleccionada(s)",
        delete: "Remover",
        deleteAria: "Fila seleccionada removida",
      },
    },
  };

  const saveUnidad = async (event) => {
    event.preventDefault();
    setLoading(true);
    let resp = await postVehiculos({
      numeroSerie: form.numero_serie,
      tipo_unidad_id: form.tipo_unidad_id,
    });

    if (resp.ok) {
      setLoading(false);
      handleClose();
      return Swal.fire({
        title: "UNIDAD",
        text: resp.msg,
        showConfirmButton: false,
        icon: "success",
        timer: 3000,
      });
    } else {
      setLoading(false);
      return Swal.fire({
        title: "Error",
        text: resp.msg,
        icon: "info",
      });
    }
  };

  const updateUnidad = async () => {
    setLoading(true);
    let err = false;

    if (
      form.cliente_gestor_telefono &&
      form.cliente_gestor_telefono !== null &&
      form.cliente_gestor_telefono.length !== 10
    ) {
      setLoading(false);
      Swal.fire({
        title: "Teléfono",
        text: "¡El número de teléfono debe de ser de 10 dígitos!",
        showConfirmButton: false,
        icon: "info",
        timer: 3000,
      });
      err = true;
    }

    let data = {};
    if (form.unidad_color !== null) data.unidad_color = form.unidad_color;
    if (form.unidad_placas !== null) data.unidad_placas = form.unidad_placas;
    if (form.unidad_marca !== null) data.unidad_marca = form.unidad_marca;
    if (form.unidad_submarca !== null)
      data.unidad_submarca = form.unidad_submarca;
    if (form.unidad_modelo !== null) data.unidad_modelo = form.unidad_modelo;
    if (form.descripcion !== null) data.descripcion = form.descripcion;
    if (form.cliente !== null) data.cliente = form.cliente;
    if (form.cliente_gestor !== null) data.cliente_gestor = form.cliente_gestor;
    if (form.cliente_gestor_telefono !== null)
      data.cliente_gestor_telefono = form.cliente_gestor_telefono;
    data.tipo_unidad_id = form.tipo_unidad_id === 4 ? 4 : 3;

    if (err === false) {
      let resp = await putActUnidadesAutosMotos(data, form.unidad_id);

      if (resp.ok) {
        setLoading(false);
        handleClose();
        Swal.fire({
          title: "UNIDAD",
          text: resp.msg,
          showConfirmButton: false,
          icon: "success",
          timer: 3000,
        });
      } else {
        setLoading(false);
        Swal.fire({
          title: "Error",
          text: resp.msg,
          icon: "info",
        });
      }
    }
  };

  const traerUnidad = async (e, registro) => {
    e.preventDefault();
    setForm({
      ...form,
      unidad_id: registro.unidad_id,
      numero_serie: registro.unidad_vin,
      tipo_unidad_id: registro.tipo_unidad_id,
      unidad_placas: registro.unidad_placas,
      unidad_marca: registro.unidad_marca,
      unidad_submarca: registro.unidad_submarca,
      cliente: registro.cliente,
      unidad_modelo: registro.unidad_modelo,
      unidad_color: registro.unidad_color,
      descripcion: registro.descripcion,
      cliente_gestor: registro.cliente_gestor,
      cliente_gestor_telefono: registro.cliente_gestor_telefono,
    });

    let resp = await getSubmarcas(registro.unidad_marca);
    if (resp.ok) {
      setCatSubMarcas([...resp.submarcas]);
    }
  };

  const handleChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  return (
    <>
      {loading && <Loader />}
      <div className="d-flex justify-content-center p-2">
        <FontAwesomeIcon
          icon={faTruck}
          className="fa-2x text-dark pb-2 mr-2 cursor"
          onClick={handleShow}
          title="Agregar unidad"
        />
        <FontAwesomeIcon
          icon={faPlus}
          className="fa text-success pb-2 mr-2 cursor"
          onClick={handleShow}
          title="Agregar unidad"
        />
      </div>

      <div className="row">
        <Tabs
          defaultActiveKey="motos"
          id="fill-tab-example"
          className="mb-3"
          fill
          onSelect={(key) => {
            if (key === "motos") {
              setSearch("");
              setTipoUnidad(3); // Cambia el tipo de unidad a motos
            }
            if (key === "autos") {
              setSearch("");
              setTipoUnidad(4); // Cambia el tipo de unidad a autos
            }
          }}
        >
          <Tab eventKey="motos" title="--MOTOS--">
            <div className="row justify-content-center">
              <div className="col-4 mt-4 inputWithIcon">
                <input
                  className="form-control selectCedis mb-4"
                  placeholder="Buscar por número de serie"
                  value={search}
                  onChange={handleChangeSearch}
                ></input>
                <button style={{ padding: "10px" }}>
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </button>
              </div>
            </div>
            <MUIDataTable
              data={dataMotos}
              columns={columns}
              options={options}
              onDownload={(buildHead, buildBody, columns, data) => {
                return "\uFEFF" + buildHead(columns) + buildBody(data);
              }}
            />
          </Tab>
          <Tab eventKey="autos" title="--AUTOS--">
            <div className="row justify-content-center">
              <div className="col-4 mt-4 inputWithIcon">
                <input
                  className="form-control selectCedis mb-4"
                  placeholder="Buscar por número de serie"
                  value={search}
                  onChange={handleChangeSearch}
                ></input>
                <button style={{ padding: "10px" }}>
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </button>
              </div>
            </div>
            <MUIDataTable
              data={dataAutos}
              columns={columns}
              options={options}
              onDownload={(buildHead, buildBody, columns, data) => {
                return "\uFEFF" + buildHead(columns) + buildBody(data);
              }}
            />
          </Tab>
        </Tabs>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {editarUnidad ? "EDITAR UNIDAD" : "CREAR UNIDAD"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row justify-content-between text-left">
            <div className="form-group col-sm-6 flex-column d-flex">
              {" "}
              <Input
                name="numero_serie"
                id="numero_serie"
                onChange={handleChange}
                value={form.numero_serie}
                type="text"
                labelText={"Número de serie"}
                placeholder={"Escribe el número de serie de la unidad"}
                classNames="mb-4"
                disabled={editarUnidad ? true : false}
              ></Input>{" "}
            </div>
            {!editarUnidad ? (
              <>
                <div className="form-group col-sm-6 flex-column d-flex">
                  <label className="form-label">
                    Selecciona un tipo de unidad
                  </label>
                  <Select
                    name="tipo_unidad_id"
                    onChange={(e) => {
                      setForm({ ...form, tipo_unidad_id: e.value });
                    }}
                    placeholder="Selecciona un tipo de unidad"
                    options={tiposVehiculos.map((x) => {
                      return { value: x.tipo_unidad_id, label: x.tipo_unidad };
                    })}
                    className="form-control mb-4"
                  ></Select>
                </div>
              </>
            ) : (
              ""
            )}
          </div>

          {editarUnidad ? (
            <>
              <div className="row">
                <div className="form-group col-sm-4 flex-column d-flex">
                  {" "}
                  <Input
                    name="unidad_placas"
                    id="unidad_placas"
                    onChange={handleChange}
                    value={form.unidad_placas}
                    type="text"
                    labelText={"Placas"}
                    placeholder={"Placas de la unidad"}
                    classNames="mb-4"
                  ></Input>{" "}
                </div>
                <div className="form-group col-sm-4 flex-column d-flex">
                  <label className="form-label">Selecciona una marca</label>
                  <select
                    name="unidad_marca"
                    className="form-control mb-4"
                    value={form.unidad_marca}
                    placeholder="Selecciona una marca"
                    onChange={async (e) => {
                      setForm({ ...form, unidad_marca: e.target.value });
                      let resp = await getSubmarcas(e.target.value);
                      if (resp.ok) {
                        setCatSubMarcas([...resp.submarcas]);
                      }
                    }}
                  >
                    <option value="" selected={true}>
                      ---
                    </option>
                    {editarMoto
                      ? catMarcasMotos.map((x, index) => {
                          return (
                            <option value={x.marca} key={index}>
                              {x.marca}
                            </option>
                          );
                        })
                      : editarAuto
                      ? catMarcasAutos.map((x, index) => {
                          return (
                            <option value={x.marca} key={index}>
                              {x.marca}
                            </option>
                          );
                        })
                      : ""}
                  </select>
                </div>
                <div className="form-group col-sm-4 flex-column d-flex">
                  <label className="form-label">Selecciona una submarca</label>
                  <select
                    name="unidad_submarca"
                    className="form-control mb-4"
                    value={form.unidad_submarca}
                    placeholder="Selecciona una submarca"
                    onChange={(e) => {
                      setForm({ ...form, unidad_submarca: e.target.value });
                    }}
                  >
                    <option value="" selected={true}>
                      ---
                    </option>
                    {catSubMarcas.map((x) => {
                      return (
                        <option value={x.submarca} key={x.submarcaId}>
                          {x.submarca}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="form-group col-sm-6 flex-column d-flex">
                  <label className="form-label">Selecciona un modelo</label>
                  <select
                    name="unidad_modelo"
                    className="form-control mb-4"
                    value={form.unidad_modelo}
                    placeholder="Selecciona un modelo"
                    onChange={(e) => {
                      setForm({ ...form, unidad_modelo: e.target.value });
                    }}
                  >
                    <option value="" selected={true}>
                      ---
                    </option>
                    {catModelos.map((cat_mode) => {
                      return (
                        <option value={cat_mode.modelo} key={cat_mode.modelo}>
                          {cat_mode.modelo}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="form-group col-sm-6 flex-column d-flex">
                  <label className="form-label">Selecciona un color</label>
                  <select
                    name="unidad_color"
                    className="form-control mb-4"
                    value={form.unidad_color}
                    placeholder="Selecciona un color"
                    onChange={(e) => {
                      setForm({ ...form, unidad_color: e.target.value });
                    }}
                  >
                    <option value="" selected={true}>
                      ---
                    </option>
                    {/* {catColores.map((x, index) => {
                                                return (
                                                    <option value={x.color} key={index}>
                                                        {x.color}
                                                    </option>
                                                );
                                            })} */}
                    {form.tipo_unidad_id === 4
                      ? catColores.autos.map((x, index) => {
                          return (
                            <option value={x.color} key={index}>
                              {x.color}
                            </option>
                          );
                        })
                      : form.tipo_unidad_id === 3
                      ? catColores.motos.map((x, index) => {
                          return (
                            <option value={x.color} key={index}>
                              {x.color}
                            </option>
                          );
                        })
                      : ""}
                  </select>
                </div>
                <div className="form-group col-sm-4 flex-column d-flex">
                  <label className="form-label">Selecciona un cliente</label>
                  <select
                    name="cliente"
                    className="form-control mb-4"
                    value={form.cliente}
                    placeholder="Selecciona un cliente"
                    onChange={(e) => {
                      setForm({ ...form, cliente: e.target.value });
                    }}
                  >
                    <option value="" selected={true}>
                      ---
                    </option>
                    {form.tipo_unidad_id === 4
                      ? catalogos.autos.map((x, index) => {
                          return (
                            <option value={x.cliente} key={index}>
                              {x.cliente}
                            </option>
                          );
                        })
                      : form.tipo_unidad_id === 3
                      ? catalogos.motos.map((x, index) => {
                          return (
                            <option value={x.cliente} key={index}>
                              {x.cliente}
                            </option>
                          );
                        })
                      : ""}
                  </select>
                </div>
                <div className="form-group col-sm-4 flex-column d-flex">
                  {" "}
                  <Input
                    name="cliente_gestor"
                    id="cliente_gestor"
                    onChange={handleChange}
                    value={form.cliente_gestor}
                    type="text"
                    labelText={"Gestor/Usuario"}
                    placeholder={"Gestor/Usuario"}
                    classNames="mb-4"
                  ></Input>{" "}
                </div>
                <div className="form-group col-sm-4 flex-column d-flex">
                  {" "}
                  <Input
                    name="cliente_gestor_telefono"
                    id="cliente_gestor_telefono"
                    onChange={handleChange}
                    value={form.cliente_gestor_telefono}
                    type="text"
                    labelText={"Teléfono"}
                    placeholder={"Teléfono"}
                    classNames="mb-4"
                  ></Input>{" "}
                </div>
                <div className="form-group col-sm-12 flex-column d-flex">
                  {" "}
                  <Input
                    name="descripcion"
                    id="descripcion"
                    onChange={handleChange}
                    value={form.descripcion}
                    type="text"
                    labelText={"Descripción"}
                    placeholder={"Descripción de la unidad"}
                    classNames="mb-4"
                  ></Input>{" "}
                </div>
              </div>
            </>
          ) : (
            ""
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-lg"
            style={{ background: "#ffcd00" }}
            onClick={editarUnidad ? updateUnidad : saveUnidad}
          >
            <FontAwesomeIcon icon={faSave} />
            &nbsp; {editarUnidad ? "Actualizar" : "CREAR"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
